module.exports = __webpack_public_path__ + "img/ImageNotFound.4aa83a5f.svg";